import { render, staticRenderFns } from "./ModalLiveClass.vue?vue&type=template&id=554a5324&"
import script from "./ModalLiveClass.vue?vue&type=script&lang=js&"
export * from "./ModalLiveClass.vue?vue&type=script&lang=js&"
import style0 from "./ModalLiveClass.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ModalLiveClass.vue"
export default component.exports